import { Form } from 'antd'

import { CreditFields } from '../CreditFields'
import { CustomerFields } from '../PersonsFields'
import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { formProps } from './utils'

export const CustomerStep = () => {
  const { priceKey } = formProps()
  const { isEditable, order } = useAccidentInsuranceValues()
  const price = Form.useWatch(priceKey.name, { preserve: true })

  const orderPrice = {
    amount: order?.full_paid_amount ? Number(order.full_paid_amount) : 0
  }

  const maxPrice = isEditable
    ? price?.amount - orderPrice?.amount
    : price?.amount

  return (
    <>
      <CustomerFields isEditable />
      <CreditFields orderPrice={maxPrice} isEditable={isEditable} />
    </>
  )
}
